"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const userProfileTranslations = {
    editProfile: "Edit Profile",
    fullName: "Full Name",
    organizationName: "Organization Name",
    emailAddress: "Email Address",
    status: "Status",
    phoneNumber: "Phone Number",
    about: "About",
    department: "Department",
    notAnswered: "Not answered",
    availableStatus: {
        acceptingPatients: "Accepting Patients",
        notAccepting: "Not Accepting",
    },
    knowMeMore: "Know Me More",
    profilePhoto: {
        takePhoto: "Take photo",
        viewPhoto: "View photo",
        uploadPhoto: "Upload photo",
    },
    countryCodeLabels: {
        US: "United States",
        INDIA: "India",
        PHILIPPINES: "Philippines",
    },
    statusUpdated: "Status updated successfully",
    statusUpdateFailed: "Status update failed",
    imageUpdated: "Image updated successfully",
    imageUpdateFailed: "Image update failed",
};
exports.default = userProfileTranslations;
